// @ts-stirct

import { Injectable } from '@angular/core';
import { IChosenSortValue } from '@app/core/models/core-models';
import { IStatisticsTableColumn, IStatsAvailableMenus } from '@services/statistics/statistics.types';
import { StatisticsColumnManagmentNumberType } from '@pages/statistics/shared/interfaces/statistics';
import { BehaviorSubject, Observable, ReplaySubject } from 'rxjs';
import { ColumnManagementOptionsType } from '../shared-statistics-functions/shared-statistics-functions.component';

const AvailableStatisticsTableColumns = [
  'leads',
  'leadToPay',
  'leadAccepted',
  'leadPending',
  'leadRejected',
  'earnings',
  'earningsToPay',
  'earningsAccepted',
  'earningsPending',
  'earningsRejected',
  'uniqueVisits',
  'conversion',
  'acceptance',
  'epc',
  'countries',
  'refferingAddress',
  'mlSub',
  'transactionId',
  'orderId',
  'additionalData',
  'cartValue',
  'created',
  'updated',
  'browser',
  'browserVersion',
  'operatingSystem',
  'operatingSystemVersion',
  'device',
  'sources',
  'configurationName',
  'rate',
  'categories',
  'status',
  'leadID',
  'visitID',
  'safePage',
  'placeOfPromotion',
  'type',
  'username',
  'model',
  'registrationDate'
] as const;

export type AvailableStatisticsTableColumns = (typeof AvailableStatisticsTableColumns)[number];

@Injectable({
  providedIn: 'root'
})
export class TableService {
  public statisticsTableOptions: IStatisticsTableColumn[] = [
    {
      id: 0,
      column: 'leads',
      text: 'lead',
      icon: 'lead',
      checked: true,
      onlyDetailsVisible: false,
      columnNameForRaportExport: 'leads'
    },
    {
      id: 1,
      column: 'leadToPay',
      text: 'toPay',
      icon: 'money-bag-alt-bold',
      checked: true,
      onlyDetailsVisible: true
    },
    {
      id: 2,
      column: 'leadAccepted',
      text: 'accepted',
      icon: 'money-protection',
      checked: true,
      onlyDetailsVisible: true,
      columnNameForRaportExport: 'leads_status_payment_waiting'
    },
    {
      id: 3,
      column: 'leadPending',
      text: 'pending',
      icon: 'money-time',
      checked: true,
      onlyDetailsVisible: true,
      columnNameForRaportExport: 'leads_status_wait'
    },
    {
      id: 4,
      column: 'leadRejected',
      text: 'rejected',
      icon: 'cross-circle',
      checked: true,
      onlyDetailsVisible: true,
      columnNameForRaportExport: 'leads_status_rejected'
    },
    {
      id: 5,
      column: 'earnings',
      text: 'earnings',
      icon: 'money-bag-alt-bold',
      checked: true,
      onlyDetailsVisible: false
    },
    {
      id: 6,
      column: 'earningsToPay',
      text: 'toPay',
      icon: 'money-bag-alt-bold',
      checked: true,
      onlyDetailsVisible: true,
      columnNameForRaportExport: 'earnings_status_to_payment'
    },
    {
      id: 7,
      column: 'earningsAccepted',
      text: 'accepted',
      icon: 'money-protection',
      checked: true,
      onlyDetailsVisible: true,
      columnNameForRaportExport: 'earnings_status_payment_waiting'
    },
    {
      id: 8,
      column: 'earningsPending',
      text: 'pending',
      icon: 'money-time',
      checked: true,
      onlyDetailsVisible: true,
      columnNameForRaportExport: 'earnings_status_wait'
    },
    {
      id: 9,
      column: 'earningsRejected',
      text: 'rejected',
      icon: 'cross-circle',
      checked: true,
      onlyDetailsVisible: true,
      columnNameForRaportExport: 'earnings_status_rejected'
    },
    {
      id: 10,
      column: 'uniqueVisits',
      text: 'unique_visits',
      icon: 'users-alt',
      checked: true,
      onlyDetailsVisible: false,
      columnNameForRaportExport: 'visits'
    },
    {
      id: 11,
      column: 'conversion',
      text: 'conversion',
      icon: 'conversion',
      checked: true,
      onlyDetailsVisible: false,
      columnNameForRaportExport: 'conversion'
    },
    {
      id: 12,
      column: 'acceptance',
      text: 'acceptance_factor',
      icon: 'like',
      checked: true,
      onlyDetailsVisible: false,
      columnNameForRaportExport: 'acceptance'
    },
    {
      id: 13,
      column: 'epc',
      text: 'epc',
      icon: 'epc',
      checked: true,
      onlyDetailsVisible: false,
      columnNameForRaportExport: 'epc'
    },
    {
      id: 14,
      column: 'countries',
      text: 'countries',
      icon: '',
      checked: true,
      onlyDetailsVisible: false,
      columnNameForRaportExport: 'country'
    },
    {
      id: 15,
      column: 'refferingAddress',
      text: 'referring_address',
      icon: '',
      checked: true,
      onlyDetailsVisible: false,
      columnNameForRaportExport: 'referrer'
    },
    {
      id: 16,
      column: 'mlSub',
      text: 'ml_sub',
      icon: '',
      checked: true,
      onlyDetailsVisible: false
    },
    {
      id: 17,
      column: 'transactionId',
      text: 'transaction_id',
      icon: '',
      checked: true,
      onlyDetailsVisible: false,
      columnNameForRaportExport: 'transaction_id'
    },
    {
      id: 18,
      column: 'created',
      text: 'created_at',
      icon: '',
      checked: true,
      onlyDetailsVisible: false,
      columnNameForRaportExport: 'created_at'
    },
    {
      id: 19,
      column: 'updated',
      text: 'updated_at',
      icon: '',
      checked: true,
      onlyDetailsVisible: false,
      columnNameForRaportExport: 'updated_at'
    },
    {
      id: 20,
      column: 'browser',
      text: 'browser',
      icon: '',
      checked: true,
      onlyDetailsVisible: false,
      columnNameForRaportExport: 'browser'
    },
    {
      id: 21,
      column: 'browserVersion',
      text: 'browser_version',
      icon: '',
      checked: true,
      onlyDetailsVisible: false,
      columnNameForRaportExport: 'browser_version'
    },
    {
      id: 22,
      column: 'operatingSystem',
      text: 'operating_system',
      icon: '',
      checked: true,
      onlyDetailsVisible: false,
      columnNameForRaportExport: 'operation_system'
    },
    {
      id: 23,
      column: 'operatingSystemVersion',
      text: 'operating_system_version',
      icon: '',
      checked: true,
      onlyDetailsVisible: false,
      columnNameForRaportExport: 'operation_system_version'
    },
    {
      id: 24,
      column: 'device',
      text: 'device',
      icon: '',
      checked: true,
      onlyDetailsVisible: false,
      columnNameForRaportExport: 'device'
    },
    {
      id: 25,
      column: 'sources',
      text: 'traffic_sources',
      icon: '',
      checked: true,
      onlyDetailsVisible: false,
      columnNameForRaportExport: 'traffic_sources'
    },
    {
      id: 26,
      column: 'configurationName',
      text: 'configuration_name',
      icon: '',
      checked: true,
      onlyDetailsVisible: false,
      columnNameForRaportExport: 'config_name'
    },
    {
      id: 27,
      column: 'rate',
      text: 'just_payout',
      icon: '',
      checked: true,
      onlyDetailsVisible: false,
      columnNameForRaportExport: 'rate'
    },
    {
      id: 28,
      column: 'categories',
      text: 'table_campaign_category',
      icon: '',
      checked: true,
      onlyDetailsVisible: false,
      columnNameForRaportExport: 'categories'
    },
    {
      id: 29,
      column: 'status',
      text: 'status',
      icon: '',
      checked: true,
      onlyDetailsVisible: false,
      columnNameForRaportExport: 'status'
    },
    {
      id: 30,
      column: 'sources',
      text: 'traffic_sources',
      icon: '',
      checked: true,
      onlyDetailsVisible: false,
      columnNameForRaportExport: 'traffic_sources'
    },
    {
      id: 31,
      column: 'leadID',
      text: 'lead_id',
      icon: '',
      checked: true,
      onlyDetailsVisible: false,
      columnNameForRaportExport: 'lead_id'
    },
    {
      id: 32,
      column: 'visitID',
      text: 'visit_id',
      icon: '',
      checked: true,
      onlyDetailsVisible: false,
      columnNameForRaportExport: 'visit_id'
    },
    {
      id: 33,
      column: 'safePage',
      text: 'safe_page',
      icon: '',
      checked: true,
      onlyDetailsVisible: false,
      columnNameForRaportExport: 'safe_page'
    },
    {
      id: 34,
      column: 'placeOfPromotion',
      text: 'place_of_promotion',
      icon: '',
      checked: true,
      onlyDetailsVisible: false,
      columnNameForRaportExport: 'promotion_place'
    },
    {
      id: 35,
      column: 'registrationDate',
      text: 'registration_date',
      icon: '',
      checked: true,
      onlyDetailsVisible: false,
      columnNameForRaportExport: 'registration_date'
    },
    {
      id: 36,
      column: 'orderId',
      text: 'order_id',
      icon: '',
      checked: true,
      onlyDetailsVisible: false,
      columnNameForRaportExport: 'order_id'
    },
    {
      id: 37,
      column: 'cartValue',
      text: 'cart_value',
      icon: '',
      checked: true,
      onlyDetailsVisible: false,
      columnNameForRaportExport: 'cart_value'
    },
    {
      id: 38,
      column: 'additionalData',
      text: 'stats_additional_data',
      icon: '',
      checked: true,
      onlyDetailsVisible: false,
      columnNameForRaportExport: 'additional_data'
    }
  ];

  private initialTableColumns: ColumnManagementOptionsType = [
    { subcategory: 'leads', results: [] },
    { subcategory: 'earnings', results: [] },
    { subcategory: 'others', results: [] }
  ];

  // private tableSortMethodSubject$ = new ReplaySubject<IChosenSortValue>(1);
  // public tableSortMethod$ = this.tableSortMethodSubject$.asObservable();
  private sortMethod$: BehaviorSubject<IChosenSortValue> = new BehaviorSubject<IChosenSortValue>({});

  public tableColumns$ = new BehaviorSubject<ColumnManagementOptionsType>(this.initialTableColumns);

  public getColumnId = (columnName: AvailableStatisticsTableColumns): number => {
    return this.statisticsTableOptions.find(({ column }) => column === columnName)?.id ?? 0;
  };

  constructor() {}

  // public setTableSortMethod = (sortMethod: IChosenSortValue) => {
  //   this.tableSortMethodSubject$.next(sortMethod);
  // };

  public getSortMethod = (): Observable<IChosenSortValue> => {
    return this.sortMethod$.asObservable();
  };

  public setSortMethod = (sortMethod: IChosenSortValue) => {
    this.sortMethod$.next(sortMethod);
  };

  public setTableColumns = (columns: ColumnManagementOptionsType) => {
    this.tableColumns$.next(columns);
  };

  public setColumnsOptions(columnManagementNumbers: StatisticsColumnManagmentNumberType, defaultVisibleColumns: AvailableStatisticsTableColumns[]) {
    const options: ColumnManagementOptionsType = [
      {
        subcategory: 'leads',
        results: columnManagementNumbers['leads']
          .map(val => this.statisticsTableOptions[val])
          .map(({ column, ...option }) => ({ ...option, column, checked: defaultVisibleColumns.includes(column) }))
      },
      {
        subcategory: 'earnings',
        results: columnManagementNumbers['earnings']
          .map(val => this.statisticsTableOptions[val])
          .map(({ column, ...option }) => ({ ...option, column, checked: defaultVisibleColumns.includes(column) }))
      },
      {
        subcategory: 'others',
        results: columnManagementNumbers['others']
          .map(val => this.statisticsTableOptions[val])
          .map(({ column, ...option }) => ({ ...option, column, checked: defaultVisibleColumns.includes(column) }))
      }
    ];

    return options;
  }

  public setActiveFilterMenus = (activeSortMethod: IChosenSortValue, activeFilterMenus: IStatsAvailableMenus): IStatsAvailableMenus => {
    const { orderField, name } = activeSortMethod;

    const campaignMenu = orderField === 'program_id' || orderField === 'day' || orderField === 'country' || orderField === 'username';

    const adminCampaignMenu = orderField === 'admin_program_id';

    const leadIDMenu = name === 'lead_id';

    const visitIDMenu = name === 'visit_id';

    const leadsMenu = orderField === 'leads' || orderField === 'number_of_leads';

    const earnsMenu = orderField === 'earnings';

    const configurationNameMenu = orderField === 'config_id';

    const visitsMenu = orderField === 'visits';

    const conversionMenu = orderField === 'conversion';

    const acceptanceMenu = orderField === 'acceptance';

    const epcMenu = orderField === 'epc';

    const rateMenu = orderField === 'rate' || orderField === 'amount';

    const countriesMenu = orderField === 'countries';

    const statusMenu = orderField === 'status';

    const createdAtMenu = orderField === 'date_created' || orderField === 'registration_date';

    const userNameMenu = orderField === 'username';

    const registrationAtMenu = orderField === 'registration_date';

    let filterMenus: IStatsAvailableMenus = {
      ...activeFilterMenus,
      campaignMenu,
      adminCampaignMenu,
      leadIDMenu,
      visitIDMenu,
      leadsMenu,
      earnsMenu,
      configurationNameMenu,
      visitsMenu,
      conversionMenu,
      acceptanceMenu,
      epcMenu,
      rateMenu,
      countriesMenu,
      statusMenu,
      createdAtMenu,
      registrationAtMenu,
      userNameMenu
    };

    return filterMenus;
  };
}
